import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import { BaseURL } from "../../Reusable/BaseURL";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function CreateVisitor() {
  const { darkTheme, loginData, getGateVisitorInfo, setGetGateVisitorInfo } =
    useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (getGateVisitorInfo?.person_name) {
      setName(getGateVisitorInfo.person_name || "");
      setMeetPsnName(getGateVisitorInfo.meet_person_name || "");
      setMobile(getGateVisitorInfo.mobile_no || "");
      setGateNo(getGateVisitorInfo.gate_no || "");
      setPurpose(getGateVisitorInfo.purpose || "");
      setRemarks(getGateVisitorInfo.remarks || "");
      setSubmitAction("update");
    }
  }, [getGateVisitorInfo.person_name]);
  const [name, setName] = useState("");
  const [meetPsnName, setMeetPsnName] = useState("");
  const [mobile, setMobile] = useState("");
  const [gateNo, setGateNo] = useState("");
  const [purpose, setPurpose] = useState("");
  const [remarks, setRemarks] = useState("");
  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);

  //   CREATE
  async function CreateFunc(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("name", divisionName);
    if (!name || !meetPsnName || !mobile || !purpose) {
      toast.error("Required fields is empty");
      return;
    }
    if (mobile.length < 10) {
      return toast.error("Mobile No. should be 10 digits");
    }
    setSubmitDisable(true);
    const formData = {
      gate_no: gateNo,
      person_name: name,
      mobile_no: mobile,
      meet_person_name: meetPsnName,
      purpose: purpose,
      remarks: remarks,
    };

    const res = await fetch(`${BaseURL}/gate-entry/create`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        // Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          //   firstPageList();
          toast.success("Successfull");
          setName("");
          setMeetPsnName("");
          setMobile("");
          setGateNo("");
          setRemarks("");
          setPurpose("");
          setSubmitDisable(false);
          navigate("/gate-entry/view-entry-visitors");
        } else {
          setSubmitDisable(false);
        }
      });
  }
  async function updateFunc(e, id) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("name", divisionName);
    if (!name || !meetPsnName || !mobile || !purpose) {
      toast.error("Required fields are empty");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      gate_no: gateNo,
      person_name: name,
      mobile_no: mobile,
      meet_person_name: meetPsnName,
      purpose: purpose,
      remarks: remarks,
    };

    const res = await fetch(`${BaseURL}/gate-entry/update/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        // Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          //   firstPageList();
          toast.success("Successfull");
          setName("");
          setMeetPsnName("");
          setMobile("");
          setGateNo("");
          setRemarks("");
          setPurpose("");
          setSubmitDisable(false);
          setSubmitAction("submit");
          setGetGateVisitorInfo({});
        } else {
          setSubmitDisable(false);
        }
      });
  }

  function cancelFun() {
    setSubmitAction("submit");
    setName("");
    setMeetPsnName("");
    setMobile("");
    setGateNo("");
    setRemarks("");
    setPurpose("");
    // setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setGetGateVisitorInfo({});
    // setEditDisable(false);
  }
  const handleMobileInp = (e) => {
    const inputValue = e.target.value;
    // Ensure only numeric input and a max length of 12
    if (/^\d*$/.test(inputValue) && inputValue.length <= 10) {
      setMobile(inputValue);
    }
  };
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div
          className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
            darkTheme ? "border-b-slate-700" : "border-b-slate-200"
          }`}
        >
          Create Visitors Entry
        </div>

        <form>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
            <MyInput
              label="Name"
              type="text"
              className="w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
              mendatory="*"
            />
            <MyInput
              label="Meet Person Name"
              type="text"
              className="w-full"
              value={meetPsnName}
              onChange={(e) => setMeetPsnName(e.target.value)}
              mendatory="*"
            />
            <MyInput
              label="Mobile"
              type="text"
              className="w-full"
              value={mobile}
              onChange={(e) => handleMobileInp(e)}
              mendatory="*"
              maxLength={"12"}
              placeholder="Enter up to 10 digits"
            />
            <MyInput
              label="Purpose"
              type="text"
              className="w-full"
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
              mendatory="*"
            />
            <MyInput
              label="Gate No."
              type="text"
              className="w-full"
              value={gateNo}
              onChange={(e) => setGateNo(e.target.value)}
            />
            <MyInput
              label="Remarks"
              type="text"
              className="w-full"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </div>

          <div className="mt-2">
            {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  disabled={submitDisable}
                  type="submit"
                  onClick={(e) => CreateFunc(e)}
                >
                  {submitDisable ? "Wait.." : "Submit"}
                </Button>
                <Button type="button" onClick={() => cancelFun()}>
                  Clear
                </Button>
              </div>
            )}

            {submitAction === "update" && (
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  //   disabled={updateDisable}
                  type="submit"
                  onClick={(e) => updateFunc(e, getGateVisitorInfo.id)}
                >
                  {updateDisable ? "Wait.." : "Update"}
                </Button>
                <Button onClick={() => cancelFun()} type="button">
                  Cancel
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
